// KD-3581 §9 — a day always announces a departure city AND an arrival city,
// even when they are the same one. The arrival follows the effective end of
// the day (a retained transfer moves it, KD-3548) and falls back to the
// departure rather than disappearing.
export function getDayLocations({
  program,
  effectiveEndPosition,
}: {
  program: any;
  effectiveEndPosition: any;
}): { startLocation: string | null; endLocation: string | null } {
  const startLocation = program?.startPosition
    ? `${program?.startPosition?.city}, ${program?.startPosition?.country}`
    : null;

  const endLocation = effectiveEndPosition
    ? `${
        effectiveEndPosition?.city ||
        effectiveEndPosition?.name ||
        effectiveEndPosition?.title ||
        ''
      }${effectiveEndPosition?.country ? `, ${effectiveEndPosition?.country}` : ''}`
    : null;

  return { startLocation, endLocation };
}
